module.exports = __webpack_public_path__ + "img/DADOS.710214d4.svg";